module.exports = __webpack_public_path__ + "media/images/default/pages/homepage/patient_recommends/img_avatar_05-0b5e6adada493aa66a327825bead7c46.png";